import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import EditDepartment from "../EditDepartment";

export const EditDepartmentModal = (props) => {
  const { isOpen, setIsOpen, department } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        setIsOpen(false);
      }}
      size={"2xl"}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Department</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <EditDepartment
            onSuccess={() => {
              setIsOpen(false);
            }}
            department={department}
          />
        </ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};
